const settings = {
    assetsPath: '/html5/assets/'
};

export default settings;
